import { createSelector } from 'reselect';
import {
    transformChallenges,
    transformUsers,
} from '../DownloadChallenges/transformers';
import { transformSegments } from './transformers';
import { transformTags } from './transformers';
import { transformMapDataImpact as transformMapData } from '../../map/transformers/';

export const AnslysisState = (state) => state.analysis || {};

export const getAnalysisChallenges = createSelector(
    AnslysisState,
    (state) => transformChallenges(state.challenges) || [],
);

export const getAnalysisResearchers = createSelector(
    AnslysisState,
    (state) => transformUsers(state.researchers) || [],
);

export const getAnalysisSegments = createSelector(
    AnslysisState,
    (state) => transformSegments(state.segments) || [],
);

export const getAnalysisSelectedChallenges = createSelector(
    AnslysisState,
    (state) => state.selectedChallenges || [],
);

export const getAnalysisSelectedResearchers = createSelector(
    AnslysisState,
    (state) => state.selectedResearchers || [],
);

export const getAnalysisSelectedSegments = createSelector(
    AnslysisState,
    (state) => state.selectedSegments || [],
);

export const getSummaryTopObjects = createSelector(
    AnslysisState,
    (state) => transformTags(state.topObjects) || [],
);

export const getSummaryTopMaterials = createSelector(
    AnslysisState,
    (state) => transformTags(state.topMaterials) || [],
);

export const getSummaryTopBrands = createSelector(
    AnslysisState,
    (state) => transformTags(state.topBrands) || [],
);

export const isSummaryTopObjectsLoading = createSelector(
    AnslysisState,
    (state) => state.isTopObjectLoading || false,
);

export const isSummaryTopMaterialsLoading = createSelector(
    AnslysisState,
    (state) => state.isTopMaterialsLoading || false,
);

export const isSummaryTopBrandsLoading = createSelector(
    AnslysisState,
    (state) => state.isTopBrandsLoading || false,
);

export const isReportRequested = createSelector(
    AnslysisState,
    (state) => state.isReportRequested || false,
);

export const isReportFinished = createSelector(
    AnslysisState,
    (state) => state.isReportFinished || false,
);

export const getObjectsTags = createSelector(
    AnslysisState,
    (state) => state.objectsTags || [],
);

export const getMaterialsTags = createSelector(
    AnslysisState,
    (state) => state.materialsTags || [],
);

export const getBrandsTags = createSelector(
    AnslysisState,
    (state) => state.brandsTags || [],
);

export const isObjectTagsLoading = createSelector(
    AnslysisState,
    (state) => state.isObjectsTagsLoading,
);

export const isMaterialTagsLoading = createSelector(
    AnslysisState,
    (state) => state.isMaterialsTagsLoading,
);

export const isBrandTagsLoading = createSelector(
    AnslysisState,
    (state) => state.isBrandsTagsLoading,
);

export const getHeatmapLitters = createSelector(
    AnslysisState,
    (state) => transformMapData(state.heatmapLitters) || [],
);

export const isHeatmapLoading = createSelector(
    AnslysisState,
    (state) => state.isHeatmapLoading,
);

export const getHeatmapStartDate = createSelector(
    AnslysisState,
    (state) => state.heatmapStartDate,
);

export const getSegmentsIndex = createSelector(
    AnslysisState,
    (state) => state.segmentsIndex || [],
);

export const isSegmentsIndexLoading = createSelector(
    AnslysisState,
    (state) => state.isSegmentsIndexLoading,
);

export const isComparisonActive = createSelector(
    AnslysisState,
    (state) => state.isComparisonActive,
);

export const isAnalysisChallengesLoading = createSelector(
    AnslysisState,
    (state) => state.isChallengesLoading,
);

export const isAnalysisResearchersLoading = createSelector(
    AnslysisState,
    (state) => state.isResearchersLoading,
);

export const isAnalysisSegmentsLoading = createSelector(
    AnslysisState,
    (state) => state.isSegmentsLoading,
);

export const getObjectsTagsCompare = createSelector(
    AnslysisState,
    (state) => state.objectsTagsCompare || [],
);

export const getMaterialsTagsCompare = createSelector(
    AnslysisState,
    (state) => state.materialsTagsCompare || [],
);

export const getBrandsTagsCompare = createSelector(
    AnslysisState,
    (state) => state.brandsTagsCompare || [],
);

/* ==== Segment group 2 / compare group selectors ==== begin */

export const getAnalysisSelectedSegmentsCompare = createSelector(
    AnslysisState,
    (state) => state.selectedSegmentsCompare || [],
);

export const getSummaryTopObjectsCompare = createSelector(
    AnslysisState,
    (state) => transformTags(state.topObjectsCompare) || [],
);

export const getSummaryTopMaterialsCompare = createSelector(
    AnslysisState,
    (state) => transformTags(state.topMaterialsCompare) || [],
);

export const getSummaryTopBrandsCompare = createSelector(
    AnslysisState,
    (state) => transformTags(state.topBrandsCompare) || [],
);

/* ==== Segment group 2 / compare group selectors ==== end */
